import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { Type } from "class-transformer";

export class AccountingAccountDto extends BaseEntityDto {
  code: string;

  description: string;

  counterpartId?: string | null;

  @Type(() => AccountingAccountDto)
  counterpart?: AccountingAccountDto | null;

  toString(): string {
    return `${this.code} ${
      this.description && this.description.length > 29 ? `${this.description.substring(0, 29)}...` : this.description
    }`;
  }
}
